import { useOutletContext } from "react-router";

import DocumentationButton from "components/DocumentationButton";
import { EmptystateDataFlowColored } from "components/icons/generated";
import Box from "ds/components/Box";
import EmptyState from "ds/components/EmptyState";
import TriggerScanButton from "shared/Scan/TriggerScanButton";
import { getDocsUrl } from "utils/getDocsUrl";
import { GET_SCAN_DETAIL } from "views/Account/Scans/ScanDetail/gql";
import { ScanResourcesOutletContext } from "views/Account/Scans/ScanResources/types";

const ScanRunsEmptyState = () => {
  const { scan } = useOutletContext<ScanResourcesOutletContext>();

  return (
    <EmptyState
      title="No runs yet"
      caption="Trigger this scan to create the first run."
      icon={EmptystateDataFlowColored}
      fullHeight
      announce
    >
      <Box gap="large">
        {scan && (
          <TriggerScanButton
            scan={scan}
            refetchQueries={[
              { query: GET_SCAN_DETAIL, variables: { id: scan.id } },
              "SearchScanRuns",
              "SearchScanRunsCount",
            ]}
          />
        )}
        <DocumentationButton
          to={getDocsUrl("/concepts/resources#account-level-resources")}
          label="Documentation"
        />
      </Box>
    </EmptyState>
  );
};

export default ScanRunsEmptyState;
